import axios from "axios";
import Cookies from "js-cookie";

export const baseURL = "https://vaghfnama.ir/api/"; //78.39.188.17  new ip address

// In-flight GET requests de-duplication store
const pendingGetRequests = new Map();

const getRequestKey = (config) => `${config.method || "get"}:${config.url}`;

const refreshToken = async () => {
  const user = Cookies.get("vaghfnamaUser");
  const parsedUser = JSON.parse(user ? user : "{}");

  try {
    const refreshResponse = await axios.post(
      `${baseURL}accounts/api/v1/jwt/refresh/`,
      { refresh: parsedUser.refresh },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const newAccessToken = refreshResponse.data.access;

    Cookies.set(
      "vaghfnamaUser",
      JSON.stringify({ ...parsedUser, access: newAccessToken }),
      { expires: 31 }
    );
    return newAccessToken;
  } catch (error) {
    console.error("Unable to refresh token:", error);
    throw new Error("Token refresh failed. Please log in again.");
  }
};

const addAuthToken = (config) => {
  const user = Cookies.get("vaghfnamaUser");
  const parsedUser = JSON.parse(user ? user : "{}");

  // Add Authorization header if access token exists
  if (parsedUser.access) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${parsedUser.access}`;
  }

  // Add CSRF token from cookies
  const csrfToken = Cookies.get("csrftoken");
  if (csrfToken) {
    config.headers = config.headers || {};
    config.headers["X-CSRFToken"] = csrfToken; // Django expects this header
  }

  return config;
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const sendRequest = async (config, useAuth) => {
  if (useAuth) {
    config = addAuthToken(config);
  }

  // Reasonable defaults
  // config.timeout = config.timeout ?? 15000;

  // De-duplicate in-flight GETs (same method+url)
  const isGet = (config.method || "get").toLowerCase() === "get";
  const requestKey = getRequestKey(config);
  if (isGet && pendingGetRequests.has(requestKey)) {
    return pendingGetRequests.get(requestKey);
  }

  const doSend = async () => axios(config);

  // Basic retry with exponential backoff for transient errors
  const maxRetries = 2; // total attempts = maxRetries + 1
  let attempt = 0;
  let lastError;

  const executor = (async () => {
    while (attempt <= maxRetries) {
      try {
        return await doSend();
      } catch (error) {
        lastError = error;
        const status = error?.response?.status;
        const isNetwork =
          error?.message === "Network Error" || error?.code === "ECONNABORTED";
        const isRetryable =
          isNetwork || status === 429 || status === 503 || status === 504;

        // Handle 401 with token refresh specially (below)
        if (status === 401 && config.headers?.Authorization) {
          try {
            const newAccessToken = await refreshToken();
            config.headers.Authorization = `Bearer ${newAccessToken}`;
            return await doSend();
          } catch (refreshError) {
            Cookies.remove("vaghfnamaUser");
            window.location.href = "/auth/login/";
            throw new Error("Unauthorized. Redirecting to login...");
          }
        }

        if (!isRetryable || attempt === maxRetries) {
          throw error;
        }

        const backoffMs = 300 * Math.pow(2, attempt); // 300ms, 600ms, 1200ms
        await delay(backoffMs);
        attempt += 1;
      }
    }
    throw lastError;
  })();

  try {
    if (isGet) pendingGetRequests.set(requestKey, executor);
    const res = await executor;
    return res;
  } catch (error) {
    console.error("Request failed:", error.message);

    if (error.message === "Network Error") {
      console.error("Network error. Please check your connection.");
      alert("اختلال در شبکه! لطفا کمی بعد تلاش کنید.");
      throw new Error("Network error. Please check your connection.");
    }

    // if (error.response?.status === 403) {
    //   const csrfError = error.response.data?.detail?.includes("CSRF Failed");
    //   if (csrfError) {
    //     console.error("CSRF validation failed.");
    //     Cookies.remove("csrftoken"); // Remove CSRF token
    //     Cookies.remove("sessionid"); // Remove session ID
    //     Cookies.remove("vaghfnamaUser"); // Remove user-specific data
    //     window.location.href = "/auth/login";
    //     throw new Error("CSRF validation failed. Please log in again.");
    //   }
    // }

    // 401 with Authorization is handled in retry loop above

    throw error; // Rethrow other errors to be handled by dataFetcher
  } finally {
    if (isGet) pendingGetRequests.delete(requestKey);
  }
};

export const dataFetcher = async (
  method,
  url,
  body,
  useAuth = false,
  onUploadProgress
) => {
  try {
    const isFormData = body instanceof FormData;

    const config = {
      method,
      url: `${baseURL}${url}`,
      data: body,
      withCredentials: true, // Include cookies in the request
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      },
      onUploadProgress,
    };

    const response = await sendRequest(config, useAuth);
    return response.data;
  } catch (error) {
    console.error(`Error in dataFetcher for ${method} ${url}:`, error.message);

    if (error.response) {
      // Handle server response errors
      console.error(
        `Server responded with status ${error.response.status}: ${error.response}`
      );
      if (error.response.status === 401) {
        throw error;
      } else if (error.response.status === 403) {
        throw error;
      } else if (error.response.status === 404) {
        throw error;
      } else if (error.response.status === 500) {
        alert("در حال حاضر سرور پاسخگو نمی باشد. لطفا بعدا دوباره تلاش کنید.");
        throw error;
      } else {
        throw error;
      }
    }

    // Handle generic errors
    throw new Error("An unknown error occurred. Please try again.");
  }
};
